import { Route, Routes, HashRouter } from 'react-router-dom';
import { LargeCenteredContainer } from '@eika/engine-view';
import React from 'react';
import { DefaultConfig } from './default-config';
import Avtale from './containers/Avtale/Avtale';
import BankIdInfo from './containers/BankIdInfo/BankIdInfo';

export interface AppProps {
    config: typeof DefaultConfig;
}

const App: React.FC<AppProps> = (props): React.ReactElement => {
    return (
        <LargeCenteredContainer>
            <HashRouter>
                <Routes>
                    <Route path="/" element={<BankIdInfo />} />
                    {/*<Route path="/" element={<Avtale {...props}/>} />*/}
                    <Route path="/aktivering" element={<Avtale {...props}/>} />
                </Routes>
            </HashRouter>
        </LargeCenteredContainer>
    );
};

export default App;
